export const isObject = value => {
  return value !== null && typeof value === 'object'
}

export const clamp = (value, min, max) => {
  return Math.min(Math.max(value, min), max)
}

export const distanceTo = (pointA, pointB) => {
  const xDiff = (pointB.x - pointA.x) ** 2
  const yDiff = (pointB.y - pointA.y) ** 2

  return Math.sqrt(xDiff + yDiff)
}

export const isDefined = value => {
  return value !== undefined && value !== null
}

export const length = (numA, numB) => {
  return Math.abs(numA - numB)
}
